import { render } from "./attendance.vue?vue&type=template&id=5ca80859&scoped=true"
import script from "./attendance.vue?vue&type=script&lang=js"
export * from "./attendance.vue?vue&type=script&lang=js"

import "./attendance.vue?vue&type=style&index=0&id=5ca80859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca80859"]])

export default __exports__